"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * False during SSR and the first client render, true afterwards — and the flip
 * re-renders the component. Use it for time-dependent values that can't rely on
 * suppressHydrationWarning: attribute content (a tooltip's `data-tip`, `title`,
 * …), or text that should switch to the viewer's timezone/locale after mount.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
